/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineAmenityDto } from './traveline-amenity-dto';
import {
    TravelineAmenityDtoFromJSON,
    TravelineAmenityDtoFromJSONTyped,
    TravelineAmenityDtoToJSON,
    TravelineAmenityDtoToJSONTyped,
} from './traveline-amenity-dto';
import type { TravelineRoomTypeSquareDto } from './traveline-room-type-square-dto';
import {
    TravelineRoomTypeSquareDtoFromJSON,
    TravelineRoomTypeSquareDtoFromJSONTyped,
    TravelineRoomTypeSquareDtoToJSON,
    TravelineRoomTypeSquareDtoToJSONTyped,
} from './traveline-room-type-square-dto';
import type { TravelineAddressDto } from './traveline-address-dto';
import {
    TravelineAddressDtoFromJSON,
    TravelineAddressDtoFromJSONTyped,
    TravelineAddressDtoToJSON,
    TravelineAddressDtoToJSONTyped,
} from './traveline-address-dto';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';
import type { TravelineOccupancyInfoDto } from './traveline-occupancy-info-dto';
import {
    TravelineOccupancyInfoDtoFromJSON,
    TravelineOccupancyInfoDtoFromJSONTyped,
    TravelineOccupancyInfoDtoToJSON,
    TravelineOccupancyInfoDtoToJSONTyped,
} from './traveline-occupancy-info-dto';
import type { TravelinePlacementDto } from './traveline-placement-dto';
import {
    TravelinePlacementDtoFromJSON,
    TravelinePlacementDtoFromJSONTyped,
    TravelinePlacementDtoToJSON,
    TravelinePlacementDtoToJSONTyped,
} from './traveline-placement-dto';

/**
 * Room type info
 * @export
 * @interface TravelineRoomTypeInfoDto
 */
export interface TravelineRoomTypeInfoDto {
    /**
     * Room type ID
     * @type {string}
     * @memberof TravelineRoomTypeInfoDto
     */
    id: string;
    /**
     * Name
     * @type {string}
     * @memberof TravelineRoomTypeInfoDto
     */
    name: string;
    /**
     * Detailed description
     * @type {string}
     * @memberof TravelineRoomTypeInfoDto
     */
    description?: string | null;
    /**
     * Room amenities
     * @type {Array<TravelineAmenityDto>}
     * @memberof TravelineRoomTypeInfoDto
     */
    amenities?: Array<TravelineAmenityDto> | null;
    /**
     * Room images
     * @type {Array<TravelineResourceDto>}
     * @memberof TravelineRoomTypeInfoDto
     */
    images?: Array<TravelineResourceDto> | null;
    /**
     * 
     * @type {TravelineRoomTypeSquareDto}
     * @memberof TravelineRoomTypeInfoDto
     */
    size?: TravelineRoomTypeSquareDto;
    /**
     * Category code
     * @type {string}
     * @memberof TravelineRoomTypeInfoDto
     */
    categoryCode: string;
    /**
     * Category name
     * @type {string}
     * @memberof TravelineRoomTypeInfoDto
     */
    categoryName: string;
    /**
     * 
     * @type {TravelineAddressDto}
     * @memberof TravelineRoomTypeInfoDto
     */
    address?: TravelineAddressDto;
    /**
     * 
     * @type {TravelineOccupancyInfoDto}
     * @memberof TravelineRoomTypeInfoDto
     */
    occupancy?: TravelineOccupancyInfoDto;
    /**
     * Accommodations entity
     * @type {Array<TravelinePlacementDto>}
     * @memberof TravelineRoomTypeInfoDto
     */
    placements: Array<TravelinePlacementDto>;
    /**
     * Order in output
     * @type {number}
     * @memberof TravelineRoomTypeInfoDto
     */
    position?: number | null;
}

/**
 * Check if a given object implements the TravelineRoomTypeInfoDto interface.
 */
export function instanceOfTravelineRoomTypeInfoDto(value: object): value is TravelineRoomTypeInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categoryCode' in value) || value['categoryCode'] === undefined) return false;
    if (!('categoryName' in value) || value['categoryName'] === undefined) return false;
    if (!('placements' in value) || value['placements'] === undefined) return false;
    return true;
}

export function TravelineRoomTypeInfoDtoFromJSON(json: any): TravelineRoomTypeInfoDto {
    return TravelineRoomTypeInfoDtoFromJSONTyped(json, false);
}

export function TravelineRoomTypeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRoomTypeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'amenities': json['amenities'] == null ? undefined : ((json['amenities'] as Array<any>).map(TravelineAmenityDtoFromJSON)),
        'images': json['images'] == null ? undefined : ((json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
        'size': json['size'] == null ? undefined : TravelineRoomTypeSquareDtoFromJSON(json['size']),
        'categoryCode': json['categoryCode'],
        'categoryName': json['categoryName'],
        'address': json['address'] == null ? undefined : TravelineAddressDtoFromJSON(json['address']),
        'occupancy': json['occupancy'] == null ? undefined : TravelineOccupancyInfoDtoFromJSON(json['occupancy']),
        'placements': ((json['placements'] as Array<any>).map(TravelinePlacementDtoFromJSON)),
        'position': json['position'] == null ? undefined : json['position'],
    };
}

  export function TravelineRoomTypeInfoDtoToJSON(json: any): TravelineRoomTypeInfoDto {
      return TravelineRoomTypeInfoDtoToJSONTyped(json, false);
  }

  export function TravelineRoomTypeInfoDtoToJSONTyped(value?: TravelineRoomTypeInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'amenities': value['amenities'] == null ? undefined : ((value['amenities'] as Array<any>).map(TravelineAmenityDtoToJSON)),
        'images': value['images'] == null ? undefined : ((value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
        'size': TravelineRoomTypeSquareDtoToJSON(value['size']),
        'categoryCode': value['categoryCode'],
        'categoryName': value['categoryName'],
        'address': TravelineAddressDtoToJSON(value['address']),
        'occupancy': TravelineOccupancyInfoDtoToJSON(value['occupancy']),
        'placements': ((value['placements'] as Array<any>).map(TravelinePlacementDtoToJSON)),
        'position': value['position'],
    };
}

